<template>
  <v-app v-if="appConfig">
    <vue-snotify />

    <app-navigation-drawer
      :items="appConfig.navigationDrawerItems"
      :navigation-drawer.sync="navigationDrawer"
      @app:exit="onAppExit"
    />

    <app-toolbar
      :items="appConfig.toolbarNavigationItems"
      :navigation-drawer.sync="navigationDrawer"
      :toolbar-title="toolbarTitle"
      @app:logout="showLogOutDialog"
    />

    <v-main>
      <slot :navigation-drawer="navigationDrawer" />

      <order-details-dialog
        :display-order="selectedOrder"
        :order-details-dialog-visible.sync="orderDetailsDialogVisible"
      />

      <confirm-dialog
        :html-content="`${$t('Common.Misc.LogoutDialog.Body')}<br>`"
        :html-title="`${$t('Common.Misc.LogoutDialog.Title')}`"
        :info-bar-body="$t('Common.Misc.LogoutDialog.Warning')"
        :title-class="'red white--text lighten-0'"
        :visible.sync="confirmDialogLogOutVisible"
        info-bar
        style="z-index: 2147483647;"
        yes-button-event="logout-yes"
        @logout-yes="onLogOutYes"
      />

      <confirm-dialog
        :html-content="`${$t('Common.Misc.ExitAppDialog.Body')}<br>`"
        :html-title="`${$t('Common.Misc.ExitAppDialog.Title')}`"
        :info-bar-body="$t('Common.Misc.ExitAppDialog.Warning')"
        :title-class="'red white--text lighten-0'"
        :visible.sync="confirmDialogExitAppVisible"
        info-bar
        style="z-index: 2147483647;"
        title-icon="exit_to_app"
        yes-button-event="exit-yes"
        @exit-yes="onExitAppYes"
      />
    </v-main>

    <v-footer
      id="appFooter"
      app
      class="secondary white--text gfp-footer px-1"
      color="grey"
      fixed
    >
      <div
        class="gfp-footer text-center"
        style="width: 100%;"
      >
        © {{ new Date().getFullYear() }} <a
          class="gfp-footer"
          href="https://www.otodev.gr/"
          target="_blank"
        ><strong>OTO Dev</strong></a> - Powered By <a
          class="gfp-footer"
          href="https://getfoodpro.gr/"
          target="_blank"
        ><strong>GETFOOD Pro</strong></a>

        <div
          v-if="posUserCan('Account', 'ACCESS')"
          class="float-right mx-1"
        >
          <v-menu
            v-model="themeMenu"
            :close-on-content-click="false"
            min-width="300"
          >
            <template #activator="{on, attrs}">
              <v-btn
                dark
                depressed
                icon
                v-bind="attrs"
                x-small
                v-on="on"
              >
                <v-icon>mdi mdi-invert-colors</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="text-body-2 font-weight-bold pa-3 pb-1">
                {{ $t('Account.Overview.Field.Theme.Title') }}

                <v-spacer />

                <v-btn
                  icon
                  small
                  @click="themeMenu = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-divider />

              <v-item-group
                v-if="posUser"
                v-model="posUser.theme_mode"
                mandatory
                @change="onSelectThemeClick"
              >
                <v-container fluid>
                  <v-row>
                    <v-col
                      v-for="theme in $t('Account.Overview.Field.Theme.Items')"
                      :key="theme.Value"
                      cols="4"
                    >
                      <v-item
                        v-slot="{active, toggle}"
                        :value="theme.Value"
                      >
                        <v-card
                          :dark="theme.Value === 'auto' ? isSystemThemeDark() : theme.Value !== 'light'"
                          :light="theme.Value === 'auto' ? !isSystemThemeDark() : theme.Value === 'light'"
                          :style="active ? 'border: #59ae4a solid 2px;' : 'border: #3b98f6 solid 2px;'"
                          :value="theme.Value"
                          max-width="85"
                          width="85"
                          @click="toggle"
                        >
                          <div class="pa-2">
                            <v-img :src="`/assets/img/${theme.Value}-mode.svg`" />

                            <v-avatar
                              v-if="active"
                              color="light-green lighten-4"
                              size="25"
                              style="position: absolute; left: -12px; top: -12px;"
                            >
                              <v-icon
                                color="success"
                              >
                                mdi-check-circle
                              </v-icon>
                            </v-avatar>
                          </div>

                          <v-divider />

                          <div class="align-start d-flex px-3 py-1">
                            <div class="d-inline-flex">
                              <div>
                                <div class="text-body-2">
                                  {{ theme.Label }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </v-card>
          </v-menu>
        </div>
      </div>
    </v-footer>

    <offline-modal :visible="offlineModalVisible" />

    <loading-modal
      :title="showLoaderTitle"
      :visible="showLoader"
    />
  </v-app>
</template>

<script>

import OrderDetailsDialog from '@/components/orders/OrderDetailsDialog.vue'
import AppNavigationDrawer from '@/components/common/AppNavigationDrawer.vue'
import AppToolbar from '@/components/common/AppToolbar.vue'
import AuthLayoutsCommon from '@/mixins/layouts/authLayoutsCommon.js'
import FooterLayoutsCommon from '@/mixins/layouts/footerLayoutsCommon.js'
import OrderLayoutsCommon from '@/mixins/layouts/orderLayoutsCommon.js'
import AppToolbarLayoutsCommon from '@/mixins/layouts/appToolbarLayoutsCommon.js'
import NavigationDrawerLayoutsCommon from '@/mixins/layouts/navigationDrawerLayoutsCommon.js'

export default {
  name      : 'KdsLayout',
  components: {
    AppToolbar,
    AppNavigationDrawer,
    OrderDetailsDialog
  },
  mixins: [
    AuthLayoutsCommon,
    OrderLayoutsCommon,
    FooterLayoutsCommon,
    NavigationDrawerLayoutsCommon,
    AppToolbarLayoutsCommon
  ],
  data() {
    return {}
  },
  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {}

}

</script>

<style>
.v-data-table__wrapper > table > tbody > tr > td {
  padding: 0 8px;
  min-height: 48px;
}

.v-application--is-ltr .v-data-footer__pagination {
  margin: 0 8px 0 2px;
}

.filter-toolbar .v-toolbar__content {
  padding: 0 6px;
}

@media only screen and (max-width: 599px) {
  .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0 8px;
    min-height: 22px !important;
  }

  .v-data-table__mobile-row__header, .v-data-table__mobile-row__cell {
    font-size: 0.75rem !important;
    line-height: 1.25rem;
    padding: 2px;
  }

  .v-slide-group__next, .v-slide-group__prev {
    flex: 0 1 28px;
    min-width: 28px;
  }
}

.gfp-footer {
  font-size: 14px;
  color: #FFFFFF;
}

.gfp-footer > a,
.gfp-footer > a:link,
.gfp-footer > a:visited,
.gfp-footer > a:active {
  text-decoration: none !important;
  color: #FFFFFF !important;
}

.gfp-footer > a:hover {
  text-decoration: underline !important;
  color: #FFFFFF !important;
}

.border-none {
  border: none !important;
}

.border-bottom-none {
  border: none !important;
}

.border-top-none {
  border: none !important;
}

.border-left-none {
  border: none !important;
}

.border-right-none {
  border: none !important;
}


.divTable {
  display: table;
  width: 100%;
  border-spacing: 0;
}

.divTableRow {
  display: table-row;
}

.v-application.theme--dark .divTableBody .divTableRow:nth-child(even) {
  background-color: #212121;
}

.v-application.theme--light .divTableBody .divTableRow:nth-child(even) {
  background-color: #F7F7F7;
}

.v-application.theme--dark .divTableBody .divTableRow:nth-child(odd) {
  background-color: #2c2c2c;
}

.v-application.theme--light .divTableBody .divTableRow:nth-child(odd) {
  background-color: #FFF;
}

.divTableCell, .divTableHead {
  border-collapse: collapse;
  display: table-cell;
  padding: 6px 6px 6px 6px;
  vertical-align: middle;
}

.divTableGroup {
  display: table-row-group;
}

.v-application.theme--dark .divTableCell, .v-application.theme--dark .divTableHead {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.v-application.theme--light .divTableCell, .v-application.theme--light .divTableHead {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.v-application.theme--dark .divTableCell {
  color: white;
}

.v-application.theme--light .divTableCell {
  color: black;
}

.divTableHead {
  color: grey;
  padding: 16px 10px;
  vertical-align: middle;
  white-space: nowrap;
}

.divTableHeading {
  display: table-header-group;
  font-weight: bold;
}

.v-application.theme--dark .divTableHeading, .v-application.theme--dark .divTableFoot {
  background-color: #191919;
}

.v-application.theme--light .divTableHeading, .v-application.theme--dark .divTableFoot {
  background-color: #EEE;
}

.divTableFoot {
  display: table-footer-group;
  font-weight: bold;
}

.divTableBody {
  display: table-row-group;
}

</style>
